module.exports = __webpack_public_path__ + "media/more_info/ai-5ecf852a.svg";